/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */

/**
 * @type {string}
 */
const MENU_ITEM_SELECTOR = '.menu-item';

/**
 * @type {string}
 */
const DROPDOWN_MENU_ITEM_SELECTOR = '.dropdown-menu-item';

/**
 * @type {string}
 */
const ACTIVE_MENU_PREFIX = 'active-menu-';

/**
 * @type {string}
 */
const MENU_OPENED_CLASS = 'opened';

export default class {
    constructor() {
        this.menuIndex = null;
        this.$menu = $('.mobile-menu');
        this.$menuToggle = $('.mobile-menu-toggle');
        this.$iconClose = $('.icon-close');
    }

    init() {
        this.$menuToggle.on('click', () => {
            this.$menu.addClass(MENU_OPENED_CLASS);
        });

        this.$iconClose.on('click', () => {
            this.$menu.removeClass(MENU_OPENED_CLASS);
        });

        this.$menu.on('click', MENU_ITEM_SELECTOR + DROPDOWN_MENU_ITEM_SELECTOR, e => {
            this._showMenu($(e.currentTarget));
        });

        $('.back-to-main').on('click', () => {
            this._hideMenu();
        });
    }

    _hideMenu() {
        if (this.menuIndex === null) {
            return;
        }

        this.$menu.removeClass(ACTIVE_MENU_PREFIX + this.menuIndex);
        this.menuIndex = null;
    }

    /**
     * @param {jQuery} $currentMenu
     */
    _showMenu($currentMenu) {
        this.menuIndex = $currentMenu.data('menu-index');
        this.$menu.addClass(ACTIVE_MENU_PREFIX + this.menuIndex);
    }
}
